/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Subscription from "./features/subscription";

const ManageSubscription = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Subscription />
        </section>
      </Layout>
    </>
  );
};
export default ManageSubscription;
